import React from 'react';
import PropTypes from 'prop-types';
import { colors } from 'Theme';

const AccountIcon = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="icon/fi-widget"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        transform="translate(2.000000, 2.000000)"
        fill={color}
        fillRule="nonzero"
        id="Shape"
      >
        <path d="M18.7848713,8.06518812 L16.3430495,7.82447525 C16.185496,7.23702265 15.9509057,6.67299929 15.6453862,6.14708911 L17.2044357,4.24776238 C17.3712918,4.04379977 17.3563945,3.74657318 17.1699802,3.56031683 L15.687208,2.07683168 C15.5009728,1.88994594 15.2031612,1.87533321 14.9995248,2.04308911 L13.1001981,3.60237624 C12.5741812,3.29690247 12.0100855,3.06231539 11.4225743,2.90471287 L11.1823367,0.462415842 C11.1564363,0.200045035 10.9358046,0 10.6721585,0 L8.575604,0 C8.31195224,0 8.09130917,0.20006117 8.06518816,0.462415842 L7.82495054,2.90542574 C7.23780602,3.06277856 6.67414951,3.29738241 6.14875252,3.60308911 L4.24823767,2.04332673 C4.15318816,1.96514851 4.03817826,1.92689109 3.92293074,1.92689109 C3.79104955,1.92689109 3.66035648,1.97726733 3.5605545,2.07730693 L2.07778222,3.56031683 C1.89136798,3.74657318 1.87647069,4.04379977 2.04332678,4.24776238 L3.6035644,6.14780198 C3.29782746,6.6734362 3.06322369,7.23733225 2.90590103,7.82471287 L0.462891132,8.06542574 C0.200299663,8.09065456 0,8.3113281 0,8.57512871 L0,10.6721584 C0,10.9359208 0.200316874,11.1569109 0.462653508,11.182099 L2.90566341,11.4228119 C3.06292832,12.0099863 3.2975369,12.5736542 3.60332678,13.0990099 L2.04403965,14.9985743 C1.87567037,15.2020166 1.89009264,15.5002485 2.07730697,15.686495 L3.56007925,17.1697426 C3.74641126,17.3564102 4.04405102,17.3710145 4.24776242,17.2034851 L6.14708915,15.644198 C6.67306539,15.9498693 7.23716641,16.1846184 7.82471291,16.3423366 L8.06495054,18.7848713 C8.09085983,19.0473326 8.31162929,19.2472871 8.57536638,19.2472871 L10.6719208,19.2472871 C10.9356832,19.2472871 11.1564357,19.0472079 11.1823367,18.7848713 L11.4225743,16.3425743 C12.0102919,16.1852489 12.5744538,15.9503945 13.1001981,15.644198 L14.9995248,17.2034851 C15.2032736,17.3709015 15.5008277,17.3563014 15.687208,17.1697426 L17.1699802,15.686495 C17.3571946,15.5002485 17.3716168,15.2020166 17.2032476,14.9985743 L15.6451486,13.0997228 C15.9506221,12.5739579 16.1852109,12.0100978 16.3428119,11.4228119 L18.7846337,11.182099 C19.0470614,11.1564278 19.2472872,10.9358387 19.2472872,10.6721584 L19.2472872,8.57512871 C19.2472872,8.31148812 19.0472583,8.0908674 18.7848713,8.06518812 L18.7848713,8.06518812 Z M9.62423767,12.4633663 C8.05520796,12.4633663 6.78392083,11.1918416 6.78392083,9.62376238 C6.78392083,8.0549703 8.05544559,6.78392079 9.62423767,6.78392079 C11.1920793,6.78392079 12.4633664,8.0549703 12.4633664,9.62376238 C12.463604,11.1918416 11.1920793,12.4633663 9.62423767,12.4633663 Z" />
      </g>
    </g>
  </svg>
);

AccountIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string
};

AccountIcon.defaultProps = {
  color: colors.gray.darkest,
  size: '24px'
};

export default AccountIcon;
